import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { DashboardScene } from 'scenes';

class DashboardContainer extends AbstractContainer {

  getTasks() {

    return [
      {
        group: 1,
        key: 'statistic',
        exec: (done, failure) => {
          API.get('statistic')
          .then((response) => {
            done(response.data);
          })
          .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <DashboardScene statistic={results.statistic} />
  }
}

export default DashboardContainer;
